
<template  minapp='mpx' xlang='wxml'>
  <controllable-drawer-bottom
    title="请登录12306"
    show="{{show}}"
    headerStyle="{{headerStyle}}"
    containerStyle="{{{zIndex: 999}}}"
    iconStyle="{{iconStyle}}"
    bind:close="closeLogin12306Drawer"
  >
    <view class="login-drawer-container">
      <view class="login-content-container">
        <view class="es-login-form">
          <!-- 快捷登录 -->
          <view class="quick-login-account" wx:if="{{loginPageStatus.quickLogin}}">
            {{ accountWithStar }}
          </view>
          <!-- 用户名 密码 输入 -->
          <block wx:if="{{loginPageStatus.commonLogin || loginPageStatus.changeUser}}">
            <view class="es-login-input">
              <input
                type="text"
                ref="name"
                class="inputStyle"
                placeholder="12306用户名/邮箱/手机号"
                wx:model="{{inputdata}}"
              />
            </view>
            <view class="es-login-input">
              <input
                type="{{passwordType}}"
                class="inputStyle"
                ref="password"
                wx:style="{{fontSizeAdapt}}"
                placeholder="请输入12306密码"
                wx:model="{{passWordData}}"
              />
              <view class="icon-eye-close" bindtap="eyehandle">
                <block wx:if="{{!eyeState}}"
                  ><image
                    src="https://pt-starimg.didistatic.com/static/starimg/img/LpvhCITOpN1642147541419.png"
                    class="es-eye"
                  ></image
                ></block>
                <block wx:else>
                  <image
                    src="https://pt-starimg.didistatic.com/static/starimg/img/FLGAZitaXS1642147590072.png"
                    class="es-eye"
                  ></image
                ></block>
              </view>
            </view>
            <view wx:if="{{accountChannel !== 'app'}}" class="es-login-input">
              <input
                type="text"
                ref="digit"
                class="inputStyle"
                placeholder="请输入登录账号绑定的证件号后四位"
                wx:model="{{digitdata}}"
              />
            </view>
            <view class="form-block"></view>
          </block>
          <!-- 协议部分 -->
          <view class="es-rm-agree-box" wx:if="{{!loginPageStatus.commonLogin}}">
            <view class="es-login-agree-left">
              <view class="es-rm-agreement">
                <es-checkbox-group wx:model="{{checkboxValue}}" direction="row">
                  <es-checkbox
                    label-position="right"
                    name="1"
                    shap="square"
                    iconSize="{{16}}"
                    icon-style="{{{borderRadius: '6px'}}}"
                    useIconSlot="{{true}}"
                    color="#338FFF"
                  >
                    <image
                      mode="aspectFit"
                      class="es-zdy-icon"
                      wx:if="{{statusCheckout}}"
                      slot="icon"
                      src="https://ut-static.udache.com/webx/sfc/f2m654Y-v5zvwcBCQw1aO.png"
                    >
                    </image>
                    <text class="es-rm-checkbox">我阅读并同意以下协议<view bindtap="goto" class="es-rm-navigator highlight es-line">《个人信息处理授权协议》</view></text>
                  </es-checkbox>
                </es-checkbox-group>
              </view>
            </view>
            <view wx:if="{{!loginPageStatus.quickLogin}}" class="es-rm-navigator" bindtap="goNext">忘记密码</view>
          </view>
          <view
            class="buttonStyle login"
            bindtap="quickLoginHandle"
            wx:if="{{loginPageStatus.quickLogin}}"
            >一键登录12306</view
          >
          <view
            class="buttonStyle login"
            bindtap="submit"
            wx:if="{{loginPageStatus.commonLogin || loginPageStatus.changeUser}}"
            >登录12306</view
          >
          <view class="register" bindtap="goRegister" wx:if="{{!loginPageStatus.quickLogin}}"
            >没有账号？30s极速注册</view
          >
          <view class="change-user" wx:else bindtap="switchUserStatus">切换账号</view>
        </view>
      </view>
      <view class="exemption-content-container" wx:if="{{!isScramble}}">
        <view class="exemption-content-container-left">
          <view class="exemption-content-container-title">
            不登录，便携购票
            <view class="service-fee" wx:if="{{serviceFee}}">{{serviceFee}}</view>
          </view>
          <view class="rights-container" wx:if="{{rightsTips.length}}">
            <view class="exemption-content-container-tips" bindclick="openRightsDescDrawer">
              <view class="tip" wx:for="{{rightsTips}}">
                <spring-icon
                  w="16"
                  h="15"
                  color="#999"
                  name="marketing-check-mark"
                  externClass="marketing-check-mark"
                />
                {{ item }}
              </view>
            </view>
            <view class="icon">
              <spring-icon
                w="16"
                h="15"
                color="#666"
                name="right-thin-arrow"
                externClass="marketing-check-mark"
              />
            </view>
          </view>
        </view>
        <view class="exemption-content-container-right">
          <view class="offline-coupon" wx:if="{{offlineCoupon}}">{{offlineCoupon}}</view>
          <view class="buy-btn" bindtap="submitOrder"> 购票 </view>
        </view>
      </view>
    </view>
  </controllable-drawer-bottom>
  <es-riskmanagement loginType="login" bindclosepopup="closeLogin12306Drawer"></es-riskmanagement>
  <!-- 协议弹窗 -->
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import { is, query } from '@didi/webx-js'
  import { RSA2_ENCRYPT } from '@/common/rsa_crypto'
  import store from '@/store'
  import { desensitize } from '@/utils/index'
  import { getFinalPrice } from '@/utils/money'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: true
      }
    },
    watch: {
      show: {
        immediate: true,
        async handler(newVal, oldVal) {
          if (newVal) {
            this.changeUserStatus = false
            this.checkboxValue = []
            this.passWordData = ''
            this.digitdata = ''
            this.inputdata = ''
            this.eyeState = false
            await this.updateAllUserAccount()
          }
        }
      }
    },
    attached() {},
    data() {
      return {
        headerStyle: {
          'justify-content': 'flex-start',
          padding: '23px 20px',
          'font-family': 'PingFangSC-Medium',
          'font-size': '18px',
          'line-height': '18px',
          color: '#000000',
          background: '#F2F6F9',
          'border-radius': '10px 10px 0px 0px',
          'box-sizing': 'border-box'
        },
        iconStyle: {
          top: '20px'
        },
        checkboxValue: [],
        passWordData: '',
        inputdata: '',
        digitdata: '',
        eyeState: false,
        changeUserStatus: false
      }
    },
    computed: {
      ...store.mapState({
        userInfo12306: 'login12306.userInfo12306',
        cxvipPopupShow: 'login12306.cxvipPopupShow',
        accountChannel: 'login12306.accountChannel',
        selectRightInfo: 'train.selectRightInfo',
        selectSeatInfo: 'train.selectSeatInfo',
        isNight: 'train.trainInfo.is_ticket_period',
      }),
      ...store.mapGetters({
        canQuickLoginAccount: 'login12306.canQuickLoginAccount',
        offlineCouponInfo: 'makeOrder.offlineCouponInfo',
      }),
      loginPageStatus() {
        const isLogin = !!this.userInfo12306?.account_with_star
        const changeUser = this.changeUserStatus
        return {
          commonLogin: !isLogin && !this.canQuickLoginAccount && !changeUser,
          quickLogin: !isLogin && this.canQuickLoginAccount && !changeUser,
          alreadyLogin: isLogin && !changeUser,
          changeUser: changeUser
        }
      },
      accountWithStar() {
        return this.canQuickLoginAccount?.account_with_star ?? ''
      },
      passwordType() {
        const type = this.eyeState ? 'text' : 'password'
        return type
      },
      statusCheckout() {
        return this.checkboxValue.length ? true : false
      },
      fontSizeAdapt() {
        const size = is('android') ? '16px' : this.eyeState ? '16px' : '10px'
        return { fontSize: size }
      },
      rightsTips() {
        const exemptionRightItem =
          this.selectSeatInfo[0]?.service_info?.offlineService
        const _rightsTips = exemptionRightItem?.tips || []
        return _rightsTips
      },
      offlineServiceFee() {
        return getFinalPrice(
          this.selectSeatInfo?.reduce((total, cur) => {
            return total + cur?.service_info?.offlineService?.fee ?? 0
          }, 0) || 0
        )
      },
      serviceFee() {
        return this.offlineServiceFee ? `+${this.offlineServiceFee}/人` : ''
      },
      isScramble() {
        return this.selectSeatInfo.every((item) => item && item.ticket_num === '无票')
      },
      offlineCoupon() {
        return this.offlineCouponInfo.amount ? `预定立减${this.offlineCouponInfo.amount / 100}元` : ''
      }
    },
    methods: {
      ...store.mapActions({
        loginAction12306: 'login12306.loginAction12306',
        updateAllUserAccount: 'login12306.updateAllUserAccount'
      }),
      ...store.mapMutations({
        setTravelerList: 'contacts.setTravelerList',
        setSelectRightInfo: 'train.setSelectRightInfo',
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource'
      }),
      closeLogin12306Drawer() {
        this.triggerEvent('close')
      },
      eyehandle() {
        if (this.eyeState) {
          this.eyeState = false
        } else {
          this.eyeState = true
        }
      },
      // 快捷登录
      quickLoginHandle() {
        this.inputBlur()
        this.setTravelerList([])
        if (!this.checkboxValue.length) {
          Dialog.confirm({
            title: '同意授权确认',
            cancelButtonText: '取消',
            confirmButtonText: '同意并继续',
            selector: '#es-dialog-conceal-login',
            confirm: () => {
              this.checkboxValue.push('1')
              this.quickLoginHandleCheck()
            },
            cancel: () => {}
          })
          return
        }
        this.quickLoginHandleCheck()
      },
      async quickLoginHandleCheck() {
        const { account, account_with_star } = this.canQuickLoginAccount
        const { from } = this.$mpxRoute.query
        this.loginAction12306({
          type: 1,
          account,
          account_with_star,
          tickets12306: from === 'tickets12306' ? 1 : 0,
          makeOrderLoginCb: this.loginSuccessHandle
        })
      },
      loginSuccessHandle() {
        if(!this.isNight) this.setMakeOrderLoginType(0)
        // 以下两个方法待执行---和后端重新约定乘车人带星修改方案
        // this.triggerEvent('loginResetPassenger') // 登录12306成功后 重置乘车人数据
        // this.triggerEvent('checkPassenger') // 登录12306后 校验乘车人数据 checkPassenger
        this.closeLogin12306Drawer()
      },
      goRegister() {
        this.closeLogin12306Drawer()
        innerRouter.push(pagePath().REGISTER)
      },
      goNext() {
        this.closeLogin12306Drawer()
        innerRouter.push(pagePath().PASSWORDRETRIEVAL)
      },
      async goto() {
        if (__mpx_mode__ === 'web') {
          const ua = navigator.userAgent.toLowerCase()
          const isUc = ua.indexOf('ucbrowser') > -1
          if (isUc) {
            this.eyeState = true
          }
        }
        let goToUrl =
          'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2\u0026policy_id=50071874'
        innerRouter.goTo(goToUrl)
      },
      checkInput() {
        const that = this
        if (this.inputdata.trim().length === 0) {
          mpx.showToast({
            title: '请输入账号名',
            icon: 'error',
            mask: true
          })
          return false
        }
        if (this.passWordData.trim().length === 0) {
          mpx.showToast({
            title: '请输入密码',
            icon: 'error',
            mask: true
          })
          return false
        }
        if (this.digitdata.trim().length === 0 && this.accountChannel !== 'app') {
          mpx.showToast({
            title: '请输入证件号后四位',
            icon: 'error',
            mask: true
          })
          return false
        }
        if (!this.checkboxValue.length) {
          Dialog.confirm({
            title: '同意授权确认',
            cancelButtonText: '取消',
            confirmButtonText: '同意并继续',
            selector: '#es-dialog-conceal-login',
            confirm: () => {
              this.checkboxValue.push('1')
              this.submit()
            },
            cancel: () => {}
          })
          return false
        }
        return true
      },
      getMaskAccount(inputdata) {
        var maskAccount = ''
        var str = '*'
        if (inputdata?.includes('@')) {
          var emialPre = inputdata.slice(0, inputdata.lastIndexOf('@'))
          if (emialPre?.length > 4) {
            maskAccount = desensitize(emialPre, 2, emialPre?.length - 2)
          } else {
            maskAccount = desensitize(emialPre, 1, emialPre?.length)
          }
          maskAccount += inputdata.slice(inputdata.lastIndexOf('@'))
        } else if (inputdata?.length >= 11) {
          maskAccount = desensitize(inputdata, 3, inputdata?.length - 4)
        } else {
          maskAccount = desensitize(inputdata, 2, inputdata?.length - 2)
        }
        return maskAccount
      },
      submit() {
        this.inputBlur()
        this.setTravelerList([])
        this.getMaskAccount(this.inputdata)
        const is_success_flag = this.checkInput()
        if (!is_success_flag) return
        const password = this.passWordData && this.passWordData.trim()
        const inputdata = this.inputdata && this.inputdata.trim()
        const digitdata = this.digitdata && this.digitdata.trim()
        const { from } = this.$mpxRoute.query
        this.loginAction12306({
          type: 0,
          password: RSA2_ENCRYPT(password),
          account: RSA2_ENCRYPT(inputdata),
          is_digit: digitdata,
          account_with_star: this.getMaskAccount(inputdata),
          tickets12306: from === 'tickets12306' ? 1 : 0,
          makeOrderLoginCb: this.loginSuccessHandle
        })
      },
      switchUserStatus() {
        this.changeUserStatus = true
      },
      submitOrder() {
        const { isRecommend } = query()
        let rightInfo
        if (this.isTransfer) {
          rightInfo = this.selectSeatInfo?.map((item) => item?.service_info?.offlineService ?? {})
        } else {
          rightInfo = [this.selectSeatInfo?.[0]?.service_info?.offlineService ?? {}]
        }
        const added_service_map = {
          1: 'make_order_float__nologin',
          2: '',
          3: ''
        }
        this.setAddedServiceSource([added_service_map[1]])
        this.setSelectRightInfo(rightInfo)
        this.closeLogin12306Drawer()
        this.triggerEvent('submit')
      },
      openRightsDescDrawer() {
        this.triggerEvent('openRightsDescDrawer')
      },
      inputBlur() {
        const inputRefArr = ['name','password', 'digit']
        inputRefArr.forEach((item) => {
            this.$refs?.[item]?.$el?.blur && this.$refs?.[item]?.$el?.blur()
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
  /deep/ .es-dialog__confirm
    color #338FFF !important
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
  .login-drawer-container
    background #F2F6F9
    display flex
    flex-direction column
    padding 40px 20px
    padding-top 0
    .exemption-content-container
      height 72px
      width 100%
      padding 0 16px
      display flex
      justify-content space-between
      align-items center
      box-sizing border-box
      margin-top 8px
      background #fff
      border-radius 8px
      &-left
        min-width 0
        flex 1
        display flex
        flex-direction column
        justify-content center
      .rights-container
        display flex
        .icon
          position relative
          top 5px
          left 4px
      &-title
        display flex
        align-items center
        font-size 16px
        line-height 16px
        font-family PingFangSC-Semibold
        font-weight 600
        color #333
        .question-mark
          margin-left 4px
        .service-fee
          font-size: 11px
          color: #999999
          margin-left: 4px
          position: relative
          top: 2px
      &-tips
        display flex
        font-family PingFangSC-Regular
        font-weight 400
        font-size 11px
        line-height 12px
        padding-top 12px
        color #666
        overflow auto hidden
        flex-wrap nowrap
        .tip
          flex-shrink 0
          display flex
          align-items center
          flex-wrap nowrap
          &:not(:last-child)
            margin-right 8px
          .marketing-check-mark
            margin-right 3px
      &-right
        display flex
        flex-direction column
        align-items center
        margin-left 32px
        .offline-coupon
          font-family PingFangSC-Regular
          font-weight 400
          font-size 11px
          line-height 12px
          color #ff5900
          margin-bottom 2px
        .buy-btn
          height 30px
          display flex
          align-items center
          white-space nowrap
          padding 0px 16px
          font-size 14px
          line-height 1
          color #fff
          background #338FFF
          border-radius 7px
          font-family PingFangSC-Medium
          font-weight 500
    .login-content-container
      width 100%
      padding 0 16px
      padding-bottom 16px
      box-sizing border-box
      background #fff
      border-radius 8px
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
  .es-rm-agree-box
    display flex
    justify-content space-between
    .es-login-agree-left
      display flex
      align-items center
      flex 1
      .es-rm-agreement
        >>> .es-rm-checkbox
          color #666
        >>> .es-checkbox--checked
          border none
    .es-rm-navigator
      display flex
      align-items center
      font-size 12px !important
      line-height 1
      color #000
      text-decoration none
      letter-spacing 0
      &.highlight
        color #338FFF
      &.es-line
        display inline
  .es-rm-checkbox
    font-size 12px
    color $train-color-999
    margin-left -5px
  .buttonStyle
    box-sizing border-box
    height 48px
    font-size 16px
    border-radius 8px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0
    display flex
    align-items center
    justify-content center
    &.login
      color #fff
      background #338FFF
      margin-top 12px
  .register
    box-sizing border-box
    color #338FFF
    font-size 12px
    line-height 14px
    margin-top 16px
    font-family PingFangSC-Regular
    font-weight 400
    text-align center
  .change-user
    box-sizing border-box
    margin-top 16px
    color #3D3D3D
    font-size 12px
    line-height 14px
    font-family PingFangSC-Medium
    font-weight 500
    text-align center
  .backgroundStyle
    padding 19px 24px 24px
    background-color #FFFFFF
    .banner
      margin-bottom 37px
      &.quick
        margin-bottom 53px
    .history-account
      margin-top 32px
  .inputStyle
    font-size 16px
    outline none
    flex 1
    height 20px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0px
    color #000000
    -webkit-tap-highlight-color transparent
    &::placeholder
      font-family PingFangSC-Regular
      font-size 16px
      font-weight normal
      line-height 1
      letter-spacing 0px
      color #999999
  .quick-login-account
    font-family PingFangSC-Medium
    font-weight 500
    font-size 24px
    line-height 24px
    color #000
    margin 30px 0
    text-align center
  .es-login-input
    height 56px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px #EEEEEE solid
    position relative
    .icon-eye-close
      flex none
      margin-left 8px
      @extend .expand-click
      width 20px
      height 20px
      .es-eye
        width 16px
        height 16px
  .form-block
    height 24px
  .es-zdy-icon
    width 16px
    height 16px
  .quick-entrance
    padding-bottom 57px
    box-sizing border-box
    width 100%
    display flex
    align-items center
    justify-content center
    .entrance-item
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      height 24px
      letter-spacing 0px
      color #000000
      margin 0 30px
      position relative
      &+.entrance-item
        margin-left 31px
        &::before
          content ''
          position absolute
          left -30px
          top 3px
          width 1px
          height 10px
          background-color #999
</style>
  
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
      'es-checkbox-group': '@/es-mpx-ui/lib/checkbox-group',
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
      'spring-icon': '@didi/spring-icon',
      'es-riskmanagement': '@/pages/login12306/components/rm/risk-management'
    }
  }
</script>